export default __webpack_public_path__ + "static/media/questboard.1445f59e.png";